<template>
  <div class="tojoin">
    <div class="banners">
      <img class="bannerImgText" :class="{'act-showsa':actShow}" src="~@/assets/img/test-drive/tojoin-text.png" alt="" />
      <img class="bannerImg" src="~@/assets/img/test-drive/tojoin-bg.jpg" alt="">
    </div>
    <div class="contents">
      <!-- 大标题 -->
      <!-- <div class="title">
        <second-title 
          englithTitle="erchants to join"
          englithA="M"
          changname="片区招商"
          addone="试乘试驾"
          addtow="片区招商"
        ></second-title>
      </div> -->
      <!-- 招商要求 -->
      <div class="investment-box animate__animated animate__slideInUp">
        <base-son-title enTitle="Investment Demand" title="招商" title1="要求"></base-son-title>
        <div class="investment-text">
          <p>1、了解并认同VOGE无极品牌和企业文化：对无极品牌在本区域的发展目标有明确的理解和实施方案。</p>
          <p>2、有合法经营主体：符合国家法律法规规定的工商税备等经营手续，且持续诚信正常经营。</p>
          <p>3、团队要求：有符合销售、服务及推广活动要求的团队。</p>
          <p>4、资金要求：提供履行合同约定的无极品牌经营保证金及运营资金。</p>
          <p>5、店面要求：有符合店面、仓储、网络、物流要求的软硬件资源。</p>
        </div>
      </div>
      <!-- 运营支持 -->
      <div class="operation-box" :class="{'animate__animated animate__slideInUp':operationShow}">
        <base-son-title enTitle="Operation Support" title="运营" title1="支持"></base-son-title>
        <div class="operation-text">
          <p>工厂将对无极门店运营、线上线下活动进行支持，提升门店销量：</p>
          <p>1、门店运营：形象、导购、出样、无极云销APP、维修服务等；</p>
          <p>2、线下活动：试乘试驾、聚会、摩旅、培训等；</p>
          <p>3、线上宣传：微信公众号、抖音及其它媒体宣传；</p>
        </div>
      </div>
      <!-- 悉知 -->
      <div class="btn" :class="{'animate__animated animate__slideInUp':btnShow}">
        <el-button class="sub-btn" @click="toPath">我已悉知</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle.vue'
import BaseSonTitle from '@/components/BaseSonTitle.vue'
export default {
  name:'tojoin',
  components:{
    SecondTitle,
    BaseSonTitle,
  },
  data(){
    return{
      actShow:false,
      currentScroll:null,
      operationShow:false,
      btnShow:false,
    }
  },
  created(){
    setTimeout(() => {
      this.actShow = true
    }, 500);
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll)
  },
  methods:{
    toPath(){
      this.$router.push('/tojoin-write')
    },
    handleScroll(){
      this.currentScroll = window.pageYOffset
      if (this.currentScroll >= 155) {
        this.operationShow = true
      }
      if (this.currentScroll >= 450) {
        this.btnShow = true
      }
    }
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  }
}
</script>
<style lang="scss">
@import './index.scss';
</style>


// WEBPACK FOOTER //
// src/views/test-drive/tojoin/tojoin-list/index.vue